import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
class CellButton extends React.Component {
    constructor(props) {
        super(props);
    }
    parentAction = (e) => {
        e.stopPropagation();
        const { action } = this.props;
        action();
    };
    render() {
        const { Description, Cellwidth, theme, textAlign, disabled } = this.props;
        this.styles = styles(theme, textAlign);
        return (
            <td width={Cellwidth}>
            <div className={css(this.styles.wrapper, !disabled && this.styles.hover)}>
                {Description && (
                <div 
                    onClick={(e) => !disabled && this.parentAction(e)} 
                    className={css(this.styles.button)} 
                    style={{ 
                    opacity: disabled ? 0.5 : 1, 
                    pointerEvents: disabled ? 'none' : 'auto', 
                    backgroundColor: disabled ? 'grey' : theme.color.themeColor 
                    }}
                >
                    <p className={css(this.styles.description)}>{Description}</p>
                </div>
                )}
            </div>
            </td>
        );
    }
}

CellButton.defaultProps = {
    Description: '',
    textAlign: 'center'
};

const mapStateToProps = ({ app }) => {
    const { theme } = app;
    return { theme };
};

export default withRouter(connect(mapStateToProps)(CellButton));

const styles = (theme, textAlign) =>
    StyleSheet.create({
        wrapper: {
            padding: '2px 10px',
            margin: 0,
            maxHeight: 55,
            overflow: 'hidden'
        },
        description: {
            fontSize: 11,
            margin: 0,
            padding: 0,
            color: 'white',
            textAlign
        },
        hover: {
            ':hover': {
                cursor: 'pointer',
                opacity: '.8'
            }
        },
        button: {
           
            padding: 5,
            borderRadius: 5,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all .2s ease-in-out'
        }
    });
